import { render, staticRenderFns } from "./v-tabs.vue?vue&type=template&id=709c7ccf&scoped=true&"
import script from "./v-tabs.vue?vue&type=script&lang=js&"
export * from "./v-tabs.vue?vue&type=script&lang=js&"
import style0 from "./v-tabs.vue?vue&type=style&index=0&id=709c7ccf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709c7ccf",
  null
  
)

export default component.exports